import React from 'react'

export const AdminOrganizations = () => {
  return <>Organizations</>
}
